import RolePermission from 'src/models/access-control/RolePermission'
import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/model'

export const CONDITIONS_REQUIREMENTS_TYPES = {
  FILTER_REPORT_CATEGORY_IDS: 'filter_report_category_ids',
  EXCLUDE_REPORT_CATEGORY_IDS: 'exclude_report_category_ids'
}
CONDITIONS_REQUIREMENTS_TYPES.ALL = _.values(CONDITIONS_REQUIREMENTS_TYPES)

export default class RolePermissionRecordRestriction extends Model {
  static name = 'RolePermissionRecordRestriction'

  static deletable = true

  static paginate = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Security]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true,
        required: true
      },

      rolePermission: {
        type: RolePermission,
        reference: true,
        encode: encoders.hasOne
      },
      restrictableId: {
        type: ID,
        required: true
      },
      restrictableType: {
        type: String,
        required: true
      }
    }
  }
}
